import * as TYPES from './types';

export default {
    [TYPES.SET_HOUSE_DETAIL_INFO](payload) {
        this.houseDetailInfo = payload;
    },
    [TYPES.SET_COUNTRY_CONFIG](payload) {
        this.countryConfig = payload;
    },

    async [TYPES.FETCH_HOUSE_DETAIL_INFO]({ hjId, type, locType, locStr }) {
        const url =
            type === 'city'
                ? '/api-site/geographic/city/' + hjId
                : `/api-site/geographic/nbr/${hjId}`;
        let { data } = await this.axiosIns.get(url, { params: { locType, locStr } });
        this[TYPES.SET_HOUSE_DETAIL_INFO](data);
    },
    async [TYPES.FETCH_COUNTRY_CONFIG]({ siteId }) {
        let { data = 'usa' } = await this.axiosIns.get(
            '/api-site/hjNbrConfig/country',
            {
                params: { siteId }
            }
        );
        this[TYPES.SET_COUNTRY_CONFIG](data);
    }
};
